import { Link } from "react-router-dom"

function Sponsers(){
    return(
        <div className="lashaqayn">
        <div className="shirkad_hayad">
            <Link to={"/"}>
            <img src="/images/Sponser3.svg" alt="sh" title="Maal Galiyaha 2aad" />
            {/* <img src="images/Logo_Takriim-07.png" alt="sh" title="Shabakada Takriim" /> */}
            </Link>
        </div>
        <div className="shirkad_hayad">
            <img src="/images/Sponser2.svg" alt="sh" title="Maal Galiyaha 2aad" />
        </div>
        <div className="shirkad_hayad">
            <img src="/images/Sponser1.svg" alt="sh" title="Maal Galiyaha 3aad" />
        </div>
        </div>
    )
}


export default Sponsers